export const NOTIFICATION_MODEL ={
    message: "",
    announcementTypeId: null,
    userId: null,
    type:"",
    title: "",
    set: function ({message, notificationTypeId, userId, title, dateMeeting=null, type = null,}) {
        return {
            ...this,
            message: message,
            announcementTypeId: notificationTypeId,
            type: type,
            dateMeeting: dateMeeting,
            userId: userId,
            title: title,
        }
    },
    isValid : function ()
    {
        return this.announcementTypeId !== null && this.title !== "" && this.message !== "";
    },
}


export const NOTIFICATION_TYPE_MODEL ={
    MEETING:{
        id:2,
        name: "MEETING",
        selectable:true
    },
    AD:{
        id:3,
        name:"AD",
        selectable:true
    },
    OTHER:{
        id:4,
        name: "OTHER",
        selectable:true
    },
    EVENT:{
        id:6,
        name: "EVENT",
        selectable:false
    },
}

export const PEOPLE_MODEL = {
    ALL_EMPLOYEES_CONTRACTORS_SUPPLIERS: 'ALL_EMPLOYEES_CONTRACTORS_SUPPLIERS',
    ONLY_EMPLOYEES: 'ONLY_EMPLOYEES',
    ONLY_CONTRACTORS: 'ONLY_CONTRACTORS',
    ONLY_SUPPLIERS: 'ONLY_SUPPLIERS',
    CHOOSE_SOME_EMPLOYEES: 'CHOOSE_SOME_EMPLOYEES',
    // Function to get list of all the model keys and values, excluding the 'getList' function
    getList: function () {
        // Use Object.entries to iterate over the key-value pairs
        return Object.entries(PEOPLE_MODEL)
            .filter(([key, value]) => key !== 'getList') // Filter out the 'getList' function itself
            .map(([key, value]) => value); // Return objects with id and name
    }
};
